import { render, staticRenderFns } from "./explore_area_carousel.vue?vue&type=template&id=893f3cc6&scoped=true"
import script from "./explore_area_carousel.vue?vue&type=script&lang=js"
export * from "./explore_area_carousel.vue?vue&type=script&lang=js"
import style0 from "./explore_area_carousel.scss?vue&type=style&index=0&id=893f3cc6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893f3cc6",
  null
  
)

export default component.exports